import { READY_REMIT_ACTIONS } from "../constants/actionTypes";
import initialState from "./initialState";

export default function allocations(state = initialState.readyremit, action) {

  if (action.type === READY_REMIT_ACTIONS.SET_AUTH) {
    return {
      ...state,
      rsp: action.payload.rsp,
      transferMethod: action.payload.transferMethod,
      encryptedAuthToken: action.payload.encryptedAuthToken,
      senderId: action.payload.senderId,
      balanceCheck: action.payload.balanceCheck
    };
  } else {
    return state;
  }
};